// Shared group-tag pill for the rollout grids (Master / Meta / Google).
// Extracted so the three grids render the group name pixel-identically
// and can't drift. Renders nothing when there's no group (Independent
// locations) — matching Master's existing "no badge for no group"
// behaviour, so the grids stay visually in parity.
//
// The group NAME is resolved by the caller via src/lib/groupTag
// (parent-chain walk); this component is purely presentational.
export function GroupBadge({ name }: { name: string | null | undefined }) {
  if (!name) return null;
  return (
    <span className="text-xs px-1.5 py-0.5 rounded bg-amber-100 text-amber-800">
      {name}
    </span>
  );
}
